import Utility from "../../../helpers/paymentHelpers/utility";
import get from "lodash/get";
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
import Headers from "../../../config/paymentConfig/headers";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import {
  common,
  RESPONSE,
  PAYMENT_ACTION,
} from "../../../helpers/paymentHelpers/paymentConstants";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../../helpers/paymentHelpers/storeKeys";

export default {
  namespaced: true,
  state: {
    submitResponse: {},
    isShowlinkWallet: true,
    paytmWalletResponse: {},
    isShowWalletLinkModal: false,
    isOtpScreenEnable: false,
    isRedeemPaytmWalletLoader: false,
    paytmLoaderTimming: 5,
    paytmLinkResponseData: {},
    paytmLinkLocalStateDataForModal: {},
    activePlaceOrderCTA: false,
    paytmErrorMsg: {
      displayMsg: "",
    },
  },
  getters: {},
  mutations: {
    updatePaytmErrorMsg(state, payload) {
      state.paytmErrorMsg.displayMsg = payload || "";
    },
    updatePaytmLinkResponseData(state, payload) {
      state.paytmLinkResponseData = payload;
    },
    updateActivePlaceOrderCTA(state, payload) {
      state.activePlaceOrderCTA = payload;
    },
    updatePaytmLinkLocalStateDataForModal(state, payload) {
      state.paytmLinkLocalStateDataForModal = payload;
    },
    updateSubmitResponse(state, payload) {
      state.submitResponse = payload;
    },
    updateShowLinkWallet(state, payload) {
      state.isShowlinkWallet = payload;
    },
    updatePaytmWalletResponse(state, payload) {
      state.paytmWalletResponse = payload;
    },
    updateWalletLinkModal(state, payload) {
      state.isShowWalletLinkModal = payload;
    },
    updateIsOtpScreenEnable(state, payload) {
      state.isOtpScreenEnable = payload;
    },
    updateIsRedeemPaytmWalletLoader(state, payload) {
      state.isRedeemPaytmWalletLoader = payload;
    },
  },
  actions: {
    togglePaytmWalletModal({ commit, state, dispatch }, payload) {
      if (payload) {
        // commit("updateWalletLinkModal", payload);
        state.isShowWalletLinkModal = payload;
        document.body.classList.add("body-stop-scroll-mobile");
        dispatch(keyMapsAction.TOGGLE_ALL_WALLET_MODAL, false, { root: true });
      } else {
        commit("updateIsOtpScreenEnable", false);
        document.body.classList.remove("body-stop-scroll-mobile");
        // commit("updateWalletLinkModal", payload);
        state.isShowWalletLinkModal = payload;
      }
    },
    toggleRedeemPaytmWalletModal({ commit, state, dispatch, rootState }, data) {
      //response, payload, action: true}
      let response = data.response;
      let payload = data.payload;
      let action = data.action;
      let timerLoad = get(
        rootState,
        "Global.appConfig.config.orderProcessTimeForWalletInSec",
        5
      );
      commit("updateIsRedeemPaytmWalletLoader", action);
      if (action) {
        document.body.classList.add("body-stop-scroll-mobile");
        setTimeout(() => {
          if (state.isRedeemPaytmWalletLoader) {
            dispatch("submitPaytmWalletRedeem", { response, payload });
            commit("PaymentSubmit/updateProgressBarOnOrderSubmit", true, {
              root: true,
            });
          }
        }, timerLoad * 1000);
      } else {
        document.body.classList.remove("body-stop-scroll-mobile");
      }
    },
    submitPaytmWalletRedeem({ commit, state, dispatch }, data) {
      try {
        let response = data.response;
        let payload = data.payload;
        const options = {
          data: payload.query,
        };
        // -- TBD for v4
        ApiCalls.PAYTM_WALLET_REDEEM_API({
          headers: Headers(),
          payload: response.paytmWalletPayload,
        })
          .then(function (res) {
            if (res?.data) {
              if (res.data.status === RESPONSE.SUCCESS) {
                switch (res.data.action) {
                  case PAYMENT_ACTION.THANKYOU:
                    dispatch(
                      keyMapsAction.AMPLITUDE_PAYMENT_STATUS,
                      { action: "Success" },
                      { root: true }
                    );
                    Utility.sendToThankYouScreen(response.orderTransactionId);
                    break;
                  case PAYMENT_ACTION.PAY_PAGE:
                    // window.location = '/payment';
                    break;
                  default:
                    // commit("ErrorModal/updateErrorModalOpen", true);
                    const errData = {
                      message: common.internalServerError,
                      headerText: common.ops,
                      rightCTAText: common.ok,
                    };
                    dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                      root: true,
                    });
                    break;
                }
              } else {
                // commit("ErrorModal/updateErrorModalOpen", true);
                const errData = {
                  message: common.internalServerError,
                  headerText: common.ops,
                  rightCTAText: common.ok,
                };
                dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                  root: true,
                });
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                message: err.displayMsg || common.internalServerError,
                headerText: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            } else if (res?.error) {
              const errData = {
                message: res.message || common.internalServerError,
                headerText: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            }
          })
          .catch(function (error) {
            console.log("ERROR in Redeem PAYTM WALLET ....101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              message: err.displayMsg || "Failed to place order",
              headerText: err.header || common.ops,
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
          });
      } catch (err) {
        console.log("ERROR in Redeem PAYTM WALLET ....102", err);
        const errData = {
          message: "Failed to place order",
          headerText: common.ops,
          rightCTAText: common.ok,
        };
        dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
      } finally {
        dispatch("toggleRedeemPaytmWalletModal", { action: false });
        commit("PaymentSubmit/updateProgressBarOnOrderSubmit", false, {
          root: true,
        });
      }
    },
  },
};
